var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            "show-confirm": false,
            "append-to-body": "",
          },
          on: { "after-close": _vm.handleAfterClose },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form" },
            [
              _c("v-form-item", { attrs: { label: "ID" } }, [
                _vm._v(" " + _vm._s(_vm.row.strategy_id) + " "),
              ]),
              _c("v-form-item", { attrs: { label: "策略类型" } }, [
                _vm._v(" " + _vm._s(_vm.row.strategy_typeshow) + " "),
              ]),
              _c("v-form-item", { attrs: { label: "产品名称" } }, [
                _vm._v(" " + _vm._s(_vm.row.product_name) + " "),
              ]),
              _c("v-form-item", { attrs: { label: "源版本" } }, [
                _vm._v(" " + _vm._s(_vm.row.source_ver) + " "),
              ]),
              _c("v-form-item", { attrs: { label: "目标版本" } }, [
                _vm._v(" " + _vm._s(_vm.row.target_ver) + " "),
              ]),
              _c("v-form-item", { attrs: { label: "策略文件地址" } }, [
                _c("span", { staticClass: "fileUrl" }, [
                  _vm._v(_vm._s(_vm.row.file_url) + " "),
                ]),
              ]),
              _c("v-form-item", { attrs: { label: "策略文件hash" } }, [
                _vm._v(" " + _vm._s(_vm.row.file_hash) + " "),
              ]),
              _c("v-form-item", { attrs: { label: "升级时间" } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.row.upgrade_type === 1
                        ? "立即升级"
                        : `${_vm.row.start_time}-${_vm.row.end_time}`
                    ) +
                    " "
                ),
              ]),
              _c("v-form-item", { attrs: { label: "上传时间" } }, [
                _vm._v(" " + _vm._s(_vm.row.created_at) + " "),
              ]),
              _c("v-form-item", { attrs: { label: "更新时间" } }, [
                _vm._v(" " + _vm._s(_vm.row.updated_at) + " "),
              ]),
              _c(
                "v-form-item",
                {
                  staticClass: "description",
                  attrs: { id: "description", label: "备注" },
                },
                [_vm._v(" " + _vm._s(_vm.row.memo) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }